// components/lobby-flow.js: pure step logic for the pre-room lobby wizard.
//
// The lobby is a tiny 3-step wizard:
//   'choose' → Create Room / Join Room (the clean landing screen)
//   'create' → "Your identity" (name + color) + the Create Room confirm
//   'join'   → "Your identity" + the room-code entry + Join
//
// Identity is collected AFTER the user picks create vs join, so the landing
// screen stays uncluttered. Extracted here (no Preact) so the transitions
// are unit-testable without jsdom.

/** @typedef {'choose'|'create'|'join'} LobbyStep */

/** @type {LobbyStep[]} */
export const LOBBY_STEPS = ['choose', 'create', 'join'];

/** The step a step name belongs to identity collection (name + color). */
export function stepShowsIdentity(step) {
  return step === 'create' || step === 'join';
}

/**
 * The step the lobby should open on. A deep-link with ?room=CODE jumps
 * straight to the join step (the code is prefilled + a background auto-join
 * fires); otherwise we start on the clean choose screen.
 *
 * @param {string|null|undefined} initialJoinCode
 * @returns {LobbyStep}
 */
export function initialLobbyStep(initialJoinCode) {
  return initialJoinCode ? 'join' : 'choose';
}
